<template>
  <div>
    <button
      type="button"
      style="
        background: rgb(247, 81, 81);
        width: 250px;
        background: linear-gradient(
          180deg,
          #ffffff 80%,
          #e66c5c 80%,
          #e66c5c 90%,
          #ffffff 90%
        );
      "
      class="btn btn-lg"
      @click="login()"
    >
      <i id="googleicon" class="fab fa-google mr-3"></i>
      <slot>Continuar com Google</slot>
    </button>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import makeToast from '../mixins/makeToast';

export default {
  name: 'GoogleButtonLogin',
  mixins: [makeToast],
  props: {
    pushToRouteName: {
      type: String,
      default: 'cliente-meus-dados',
    },
  },
  computed: {
    ...mapState({
      dadosUsuario: (state) => state.dadosUsuario,
    }),
    ...mapGetters(['getNotification']),
  },
  methods: {
    async login() {
      let authCode;

      try {
        authCode = await this.$gAuth.signIn();
      } catch (exception) {
        this.makeToast(
          'Ooops',
          'Parece que algo deu errado no Login, tente novamente mais tarde',
          'danger'
        );
        return;
      }

      const network = {
        provider: 'google',
        accessToken: authCode.getAuthResponse().access_token,
      };

      this.$store.dispatch('startLoader');
      await this.$store
        .dispatch('login/socialLogin', network)
        .then(() => {
          this.$store.dispatch('endLoader');
          if (this.dadosUsuario !== null) {
            this.makeToast('Sucesso', 'Login realizado com sucecsso');

            this.$emit('closeUserTypeModal');

            setTimeout(() => {
              this.$router.push({ name: this.$props.pushToRouteName });
            }, 1000);
          } else {
            this.$store.dispatch('endLoader');
            this.makeToast('Oops', this.getNotification, 'danger');
          }
        })
        .catch(() => {
          this.$store.dispatch('endLoader');
          this.makeToast('Ooops', this.getNotification, 'danger');
        });
    },
    OnGoogleAuthFail() {
      this.makeToast(
        'Ooops',
        'Parece que algo deu errado ao se autenticar usando o Google, tente novamente mais tarde',
        'danger'
      );
    },
  },
};
</script>

<style scoped>
.btn {
  border: 1.4px solid var(--grey);
  border-radius: 8px;
}

.icon {
  width: 24px;
}

#googleicon {
  color: #e64343;
}
</style>
